import React, { useEffect, useRef } from 'react';
import { View, Animated, Easing } from 'react-native';

interface LoadingSpinnerProps {
    size?: 'small' | 'medium' | 'large';
    color?: 'white' | 'primary' | 'secondary';
    className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
    size = 'medium',
    color = 'white',
    className = ''
}) => {
    const spinValue = useRef(new Animated.Value(0)).current;

    useEffect(() => {
        Animated.loop(
            Animated.timing(spinValue, {
                toValue: 1,
                duration: 1500,
                easing: Easing.linear,
                useNativeDriver: true,
            }),
        ).start();
    }, [spinValue]);

    const spin = spinValue.interpolate({
        inputRange: [0, 1],
        outputRange: ['0deg', '360deg'],
    });

    const sizeClasses = {
        small: 'h-6 w-6 border-2 ',
        medium: 'h-10 w-10 border-4 ',
        large: 'h-32 w-32 border-8 '
    };

    const colorClasses = {
        white: 'border-white border-t-transparent',
        primary: 'border-primary-700 border-t-transparent',
        secondary: 'border-secondary-600 border-t-transparent'
    };

    return (
        <Animated.View style={{ transform: [{ rotate: spin }] }}>
            <View
                className={`${sizeClasses[size]} ${colorClasses[color]} rounded-full ${className}`}
            />
        </Animated.View>
    );
};

export default LoadingSpinner;
